import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=81221a1e&"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts&"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports